import { render, staticRenderFns } from "./Dashboard800View.vue?vue&type=template&id=22bedd49&scoped=true&"
import script from "./Dashboard800View.vue?vue&type=script&lang=js&"
export * from "./Dashboard800View.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard800View.vue?vue&type=style&index=0&id=22bedd49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bedd49",
  null
  
)

export default component.exports